export const ApiErrorCode = {
  conflict: 409,
  internalServerError: 500,
  preConditionFailed: 412,
  preConditionRequired: 428,
  unprocessableEntity: 422,
};
